import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuditLogCategory } from '@cdw-ae/common-data';
import {
  // Commented out error dialog for when a user does not have gopher access
  // user types need to be implemented
  // CdwConfirmationDialogComponent,
  // CdwConfirmationDialogData,
  CdwDialogModule,
} from '@cdw-ae/common-ui-components-dialog';
// Commented out error dialog for when a user does not have gopher access
// user types need to be implemented
// import { MatDialog } from '@cdw-ae/common-frontend-materials';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';
import { Store, select } from '@ngrx/store';
import { catchError, filter, firstValueFrom, of, take } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { selectCurrentUserData } from '../../../../+state/user-identity/user-identity-settings.selectors';
import { GoogleLoginButtonComponent } from '../../../../common/components/google-login-button/google-login-button.component';
import { AuditLogBuilderService } from '../../../../common/services/audit-log/audit-log-builder.service';
import {
  AuthenticationService,
  LoginProvider,
} from '../../../../common/services/authentication/authentication.service';
// import { TailwindColors } from '../../../../common/constants/tailwind-colors';
// const HIDE_ACCESS_ERROR_STORAGE_KEY = 'hideAccessError';   // Commented out error dialog for when a user does not have gopher access
// user types need to be implemented

@Component({
  selector: 'splash-screen',
  imports: [
    CommonModule,
    GoogleLoginButtonComponent,
    CdwIconModule,
    CdwDialogModule,
  ],
  templateUrl: './splash.component.html',
  styleUrl: './splash.component.scss',
})
export class SplashComponent implements OnInit {
  isLoading = false;
  loginError: string | null = null;
  readonly helpCenterUrl = environment.urls.support.helpCenter;
  readonly privacyUrl = environment.urls.legal.privacyNotice;

  constructor(
    private authenticationService: AuthenticationService,
    private auditLogBuilder: AuditLogBuilderService,
    private store: Store,
    private route: ActivatedRoute
    // private dialog: MatDialog   // Commented out error dialog for when a user does not have gopher access
    // user types need to be implemented
  ) {}

  ngOnInit(): void {
    const authError = this.route.snapshot.queryParamMap.get('authError');
    if (authError) {
      this.loginError = decodeURIComponent(authError);
    }
  }

  async handleGoogleLogin(): Promise<void> {
    this.isLoading = true;
    this.loginError = null;

    try {
      await this.authenticationService.login(LoginProvider.Google);

      // Wait for authentication to complete and user data to be populated
      // Use RxJS operators to wait for valid user data
      firstValueFrom(
        this.store.pipe(
          select(selectCurrentUserData),
          filter((userData) => {
            // Only proceed when we have valid, authenticated user data
            return !!(
              userData?.claims?.core?.firebaseUserId &&
              userData?.claims?.core?.dbUserId &&
              userData?.email &&
              userData?.token &&
              userData?.emailVerified !== undefined
            );
          }),
          take(1)
        )
      )
        .then(async (userData) => {
          // Create login audit log with validated user data
          if (userData?.claims?.core?.dbUserId) {
            await firstValueFrom(
              this.auditLogBuilder
                .createAuditLog({
                  userId: userData.claims.core.dbUserId,
                  category: AuditLogCategory.AUTHENTICATION,
                  operationType: 'Login',
                  action: 'User Logged In',
                  description: 'User successfully logged in',
                })
                .pipe(
                  catchError((_error) => {
                    // Failed to create logout audit log, but continue
                    return of(null);
                  })
                )
            );
          }
        })
        .catch(() => {
          // Failed to get user data or create audit log, but continue
        });
    } catch (error: unknown) {
      const message =
        error instanceof Error ? error.message : 'Please try again.';
      this.loginError = `Login failed: ${message}`;
    } finally {
      this.isLoading = false;
    }
  }

  // Commented out error dialog for when a user does not have gopher access
  // user types need to be implemented
  // public openErrorDialog(): void {
  //   // Check if user has chosen to hide this dialog
  //   const hideDialog = localStorage.getItem(HIDE_ACCESS_ERROR_STORAGE_KEY);
  //   if (hideDialog === 'true') {
  //     return;
  //   }

  //   const dialogData: CdwConfirmationDialogData = {
  //     titleFontFamily: 'Source Sans 3',
  //     titleFontWeight: 800,
  //     titleFontSize: '22px',
  //     title: 'Unable to access Gopher for Chrome',
  //     message: 'Before you can access this site, a super admin from your domain must enable the device cache in the companion Google Sheet Add-on.\n\n',
  //     type: 'error',
  //     size: 'medium',
  //     confirmText: 'OK',
  //     showCancelButton: false,
  //     showDontShowAgainCheckbox: true,
  //     dontShowAgainText: "Don't show again",
  //     fontFamily: 'Roboto',
  //     messageFontWeight: 400,
  //     messageFontSize: '16px',
  //     linkColor: TailwindColors.tertiaryBlueLink,
  //     hard: false,
  //     hideIcon: true,
  //     linkUrl: 'https://amplifiedlabs.zendesk.com/hc/en-us',
  //     linkText: 'Please visit our help desk for more information.',
  //     contentPadding: '3rem'
  //   };

  //   const dialogRef = this.dialog.open(CdwConfirmationDialogComponent, {
  //     width: '540px',
  //     maxWidth: '90vw',
  //     data: dialogData,
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result?.dontShowAgain) {
  //       localStorage.setItem(HIDE_ACCESS_ERROR_STORAGE_KEY, 'true');
  //     }
  //   });
  // }
}
